<template>
  <div class='body-box'>
    <el-row class='plan'>
      <el-col :span='19'>
        <el-button icon='el-icon-plus' @click='handleAdd'>新增</el-button>
      </el-col>
      <el-col :span='5'>
        <search-input v-model='queryInfo.name' placeholder='请输入菜单名称' @change="handleQuery" />
      </el-col>
    </el-row>

    <!-- 菜单列表区域 -->
    <el-table :height="'calc(100% - 70px)'" :data='menulist' row-key='id' sort-by='sort' class='button-box' :tree-props="{ children: 'menuChildList' }">
      <el-table-column prop='name' label='菜单名称' width='180' class='left' />
      <el-table-column prop='icon' label='图标' icon='el-icon-eleme'>
        <template slot-scope='scope'>
          <i :class='scope.row.icon'></i>
        </template>
      </el-table-column>
      <el-table-column prop='router' label='路由地址' />
      <el-table-column prop='enumShow' label='状态'>
        <template slot-scope='scope'>{{ scope.row.enumShow | formatYESNo }}</template>
      </el-table-column>
      <el-table-column prop='createDatetime' label='创建时间'>
        <template slot-scope='scope'>{{ scope.row.createDatetime | formatDate }}</template>
      </el-table-column>
      <el-table-column label='操作' width='180'>
        <template slot-scope='scope'>
          <el-button icon='el-icon-edit' @click='editMenu(scope.row.id)'>修改</el-button>
          <el-button icon='el-icon-delete' @click='removeMenuById(scope.row.id)'>删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 添加菜单对话框 -->
    <el-dialog title='新增菜单' :visible.sync='open' width='50%' @close='addDialogClosed'>
      <el-alert title='创建一级菜单不需要选择上级菜单' type='warning' style='margin-bottom: 20px'></el-alert>
      <el-form ref='addFormRef' :model='addForm' :rules='rules' label-width='100px'>
        <el-row>
          <el-col :span='24' v-if='addForm.menuId !== 0'>
            <el-form-item label='上级菜单'>
              <treeselect
                v-model='addForm.menuId'
                :normalizer='normalizer'
                :options='menulist'
                style='margin-left: 0.5rem'
                placeholder='选择上级菜单'
              />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='菜单名称' prop='name'>
              <el-input v-model='addForm.name' placeholder='请输入菜单名称' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='菜单图标' prop='icon'>
              <el-input v-model='addForm.icon' placeholder='点击选择图标'></el-input>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='菜单层级' prop='level'>
              <el-input v-model='addForm.level' placeholder='请输入新增菜单的层级' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='显示排序' prop='sort'>
              <el-input-number v-model='addForm.sort' controls-position='right' :min='0' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='路由地址' prop='router'>
              <el-input v-model='addForm.router' placeholder='请输入路由地址' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='是否展示' prop='enumShow'>
              <el-select v-model='addForm.enumShow' placeholder='请选择'>
                <el-option
                  v-for='item in enumOptions'
                  :key='item.value'
                  :label='item.name'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='默认菜单'>
              <el-select v-model='addForm.enumDefault' placeholder='请选择'>
                <el-option
                  v-for='item in defaultOptions'
                  :key='item.value'
                  :label='item.name'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='徽章选择'>
              <el-select v-model='addForm.badgeKey' placeholder='请选择'>
                <el-option
                  v-for='item in badgeKeyLists'
                  :key='item.value'
                  :label='item.name'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>
      <div class='dialog-footer'>
        <el-button @click='open = false'>取 消</el-button>
        <el-button @click='addMenu'>确 定</el-button>
      </div>
    </el-dialog>

    <!-- 修改菜单对话框 -->
    <el-dialog title='修改菜单' :visible.sync='editOpen' width='50%' @close='addDialogClosed'>
      <el-form ref='addFormRef' :model='editForm' :rules='rules' label-width='100px'>
        <el-row>
          <el-col :span='24'>
            <el-form-item label='选择上级菜单'>
              <treeselect
                v-model='editForm.menuId'
                :normalizer='normalizer'
                :options='menulist'
                placeholder='选择需要修改的上级菜单'
              />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='菜单名称' prop='name'>
              <el-input v-model='editForm.name' placeholder='请输入菜单名称' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item v-if='editForm.icon' label='菜单图标' prop='icon'>
              <el-input v-model='editForm.icon' placeholder='点击选择图标'></el-input>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item v-if='editForm.level' label='菜单层级' prop='level'>
              <el-input v-model='editForm.level' placeholder='请输入修改菜单的层级' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='显示排序' prop='sort'>
              <el-input-number v-model='editForm.sort' controls-position='right' :min='0' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='路由地址' prop='router'>
              <el-input v-model='editForm.router' placeholder='请输入路由地址' />
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='是否展示' prop='enumShow'>
              <el-select v-model='editForm.enumShow' placeholder='请选择'>
                <el-option
                  v-for='item in enumOptions'
                  :key='item.value'
                  :label='item.name'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='默认菜单'>
              <el-select v-model='editForm.enumDefault' placeholder='请选择'>
                <el-option
                  v-for='item in defaultOptions'
                  :key='item.value'
                  :label='item.name'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span='12'>
            <el-form-item label='徽章选择'>
              <el-select v-model='editForm.badgeKey' placeholder='请选择'>
                <el-option
                  v-for='item in badgeKeyLists'
                  :key='item.value'
                  :label='item.name'
                  :value='item.value'
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot='footer' class='dialog-footer'>
        <el-button @click='editOpen = false'>取 消</el-button>
        <el-button @click='modifyMenu'>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import {
  addMenu,
  deleteMenu,
  selectAllMenu,
  selectMenuById,
  treeMenu,
  updateMenu
} from '@/api/user/menu/menu'
import { getData, getPageData, getPostOrDeleteData } from '@/utils/code'
import { deleteTips, title } from '@/utils/tips'
import { getDictList } from '@/api/user/dict/dict'
import SearchInput from '@/components/common/searchInput/searchInput'
import { menuRules } from '@/js/rules'
import { enumEnable, payYesNo } from '@/js/enum'
export default {
  components: { SearchInput, Treeselect },
  data() {
    return {
      dialogVisibleImg: false,
      dialogImageUrl: '',
      // 查询参数
      queryInfo: {
        name: '',
        current: 1,
        size: 1000
      },
      menulist: [],
      // 菜单树选项
      menuOptions: [],
      open: false,
      editOpen: false,
      // 表单参数
      addForm: {
        enumDefault: 'NO',
        enumShow: 'YES',
        badgeKey: ''
      },
      editForm: {badgeKey: ''},
      // 表单校验
      rules: menuRules,
      // 枚举是YES、NO 不是NORMAL、DISABLE
      enumOptions: payYesNo,
      badgeKeyLists: [],
      // 枚举是YES、NO 不是NORMAL、DISABLE
      defaultOptions: payYesNo,
      // 查询参数
      dictListQueryInfo: {
        current: 1,
        size: 1000,
        key: ''
      },
      fileList: []
    }
  },
  created() {
    this.getMenuList()
    this.getDictList()
  },
  methods: {
    // 所有列表
    getDictList() {
      getDictList(this.dictListQueryInfo).then((response) => {
        let data = getData(response).records
        let arr = []
        // data
        data.forEach((item) => {
          if (item.keyword === 'PROCESS_KEY') {
            arr.push(item)
          }
        })
        arr.unshift({
          describe: '',
          id: '',
          keyword: '',
          name: '禁用徽章',
          value: ''
        })
        this.badgeKeyLists = arr ? arr : []
        // this.total = parseInt(data.total)
      })
    },
    // 获取列表
    getMenuList() {
      treeMenu(this.queryInfo).then((response) => {
        this.menulist = getPageData(response) ? getPageData(response) : []
      })
    },

    editHandleRemove(file, fileList) {
      this.fileList = fileList
    },

    //搜索
    getHande() {
      selectAllMenu(this.queryInfo).then((response) => {
        this.menulist = getPageData(response) ? getPageData(response) : []
      })
    },

    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.menuChildList && !node.menuChildList.length) {
        delete node.children
      }
      return {
        name: node.name,
        id: node.id,
        label: node.name,
        children: node.menuChildList
      }
    },

    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      // 重置添加默认值
      this.addForm = {
        enumShow: 'YES',
        enumDefault: 'NO'
      }
    },

    handleAdd() {
      this.open = true
    },

    /** 搜索按钮操作 */
    handleQuery() {
      if (this.queryInfo.name === '') {
        this.getMenuList()
      } else {
        this.getHande()
      }
    },
    // 添加菜单
    addMenu() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        return
        addMenu(this.addForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getMenuList()
            this.open = false
          }
        })
      })
    },

    // 根据菜单ID查询菜单信息
    editMenu(id) {
      selectMenuById(id).then((response) => {
        this.editForm = getData(response) ? getData(response) : []
        this.editOpen = true
      })
    },

    //修改菜单
    modifyMenu() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return
        if (!this.editForm.menuId) {
          this.editForm.menuId = null
        }
        return
        updateMenu(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getMenuList()
            this.editOpen = false
          }
        })
      })
    },

    // 删除
    async removeMenuById(id) {
      let b = await deleteTips(title.deleteTitle)
      if (b) {
        deleteMenu(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.getMenuList()
            this.editOpen = false
          }
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
/deep/ .el-table--enable-row-transition .el-table__body td:nth-child(1) .cell {
  text-align: left;
}

/deep/ .el-input-number.is-controls-right .el-input-number__increase {
  border-bottom: none;
}

/deep/ .el-input-number__increase {
  border-bottom: none;
}

/deep/ .el-input-number.is-controls-right .el-input-number__decrease {
  border-left: none;
}

/deep/ .el-input-number__decrease,
.el-input-number__increase {
  background-color: #fff;
}

/deep/ .el-input-number__increase {
  border-left: none;
  background-color: #fff;
}

/deep/ .el-input-number--small,
.el-select {
  width: 100%;
}
</style>
